export const extractEntityData = (response) => {
    if (response?.isSuccess && response?.data) {
        return response.data;
    }

    if (response?.data) {
        return response.data;
    }

    return response || null;
};

export const mergeLicensePlateAndCustomerData = ({
    prevFormData,
    customerData,
    licensePlateData,
    fallbackCustomerId,
}) => {
    return {
        ...prevFormData,
        ...(customerData && {
            customerId: customerData.id || fallbackCustomerId,
            clientName: customerData.customerType === 'Bireysel' ? (customerData.clientName || null) : null,
            companyName: customerData.customerType === 'Kurumsal' ? (customerData.companyName || null) : null,
            tcid: customerData.customerType === 'Bireysel' ? (customerData.identityNumber || null) : null,
            crsNumber: customerData.customerType === 'Kurumsal' ? (customerData.crsNumber || null) : null,
            taxNumber: customerData.customerType === 'Kurumsal' ? (customerData.taxNumber || null) : null,
            customerType: customerData.customerType || 'Bireysel',
            companyRepresentative: customerData.companyRepresentative || null,
            phoneNumber: customerData.phones?.[0]?.phone || null,
            phoneDescription: customerData.phones?.[0]?.phoneDescription || null,
            phoneNumber2: customerData.phones?.[1]?.phone || null,
            phoneDescription2: customerData.phones?.[1]?.phoneDescription || null,
            email: customerData.emails?.[0]?.email || null,
            emailDescription: customerData.emails?.[0]?.emailDescription || null,
            email2: customerData.emails?.[1]?.email || null,
            emailDescription2: customerData.emails?.[1]?.emailDescription || null,
            iban: customerData.ibans?.[0]?.iban || null,
            ibanDescription: customerData.ibans?.[0]?.ibanDescription || null,
            iban2: customerData.ibans?.[1]?.iban || null,
            ibanDescription2: customerData.ibans?.[1]?.ibanDescription || null,
            address: customerData.address || null,
            city: customerData.district?.city?.id || null,
            district: customerData.district?.id || null,
            recipientOfPowerOfAttorney: customerData.agent ? `${customerData.agent.firstName} ${customerData.agent.lastName}`.trim() : null,
            agentId: customerData.agent?.id || null,
            reference: customerData.reference || null,
            middleman: customerData.middleman || null,
            middlemanIban: customerData.middlemanIban || null,
            hasContractArrived: customerData.contractOriginalArrived ? 'yes' : 'no',
            customerContractRate: customerData.customerContractRate !== undefined ? customerData.contractRate?.toString() : null,
            customerEnforcementAttorneyFeeShareRate: customerData.enforcementAttorneyFeeShareRate?.toString() ?? null,
            customerJudgmentAttorneyFeeShareRate: customerData.judgmentAttorneyFeeShareRate?.toString() ?? null,
            customerPayInterestToCustomer: customerData.payInterestToCustomer === true,
            customerIsMiddlemanContractBased: customerData.isMiddlemanContractBased === true,
            customerMiddlemanContractRate: customerData.isMiddlemanContractBased === true
                ? (customerData.middlemanContractRate !== undefined ? customerData.middlemanContractRate?.toString() : null)
                : null,
            customerMiddlemanContractPrice: customerData.isMiddlemanContractBased === false
                ? (customerData.middlemanContractPrice !== undefined ? customerData.middlemanContractPrice.toString() : null)
                : null,
        }),
        ...(licensePlateData && {
            licensePlate: licensePlateData.licensePlateNumber || null,
            chassisNumber: licensePlateData.carchassisNumber || null,
            carBrand: licensePlateData.carBrand || null,
            carModel: licensePlateData.carModel || null,
            carYear: licensePlateData.carYear || null,
            hasCarSoldBefore: licensePlateData.hasCarSoldBefore ? 'yes' : 'no',
            isThereLovClaim: licensePlateData.isThereLovClaim ? 'yes' : 'no',
            lovClaimAmount: licensePlateData.lovClaimAmount || null,
            lpImpeachmentStatus: licensePlateData.lpImpeachmentStatus ? 'yes' : 'no',
            lpImpeachmentAmount: licensePlateData.lpImpeachmentAmount || null,
            licensePlateCustomerContractRate: licensePlateData.customerContractRate !== undefined ? licensePlateData.customerContractRate?.toString() : null,
            licensePlateEnforcementAttorneyFeeShareRate: licensePlateData.enforcementAttorneyFeeShareRate?.toString() ?? null,
            licensePlateJudgmentAttorneyFeeShareRate: licensePlateData.judgmentAttorneyFeeShareRate?.toString() ?? null,
            licensePlatePayInterestToCustomer: licensePlateData.payInterestToCustomer === true,
            licensePlateIsMiddlemanContractBased: licensePlateData.isMiddlemanContractBased === true,
            licensePlateMiddlemanContractRate: licensePlateData.isMiddlemanContractBased === true
                ? (licensePlateData.middlemanContractRate !== undefined ? licensePlateData.middlemanContractRate?.toString() : null)
                : null,
            licensePlateMiddlemanContractPrice: licensePlateData.isMiddlemanContractBased === false
                ? (licensePlateData.middlemanContractPrice !== undefined ? licensePlateData.middlemanContractPrice?.toString() : null)
                : null,
            trafficInsurancePolicy: {
                trafficInsuranceProvider: licensePlateData.trafficInsurancePolicy?.trafficInsuranceProvider?.id
                    ? [licensePlateData.trafficInsurancePolicy.trafficInsuranceProvider.id]
                    : [],
                trafficInsuranceNumber: licensePlateData.trafficInsurancePolicy?.trafficInsuranceNumber || null,
                trafficInsuranceStart: licensePlateData.trafficInsurancePolicy?.trafficInsuranceStart
                    ? new Date(licensePlateData.trafficInsurancePolicy.trafficInsuranceStart)
                    : null,
                trafficInsuranceExpiry: licensePlateData.trafficInsurancePolicy?.trafficInsuranceExpiry
                    ? new Date(licensePlateData.trafficInsurancePolicy.trafficInsuranceExpiry)
                    : null,
            },
            cascoInsurancePolicy: {
                cascoInsuranceProvider: licensePlateData.cascoInsurancePolicy?.cascoInsuranceProvider?.id
                    ? [licensePlateData.cascoInsurancePolicy.cascoInsuranceProvider.id]
                    : [],
                cascoInsuranceNumber: licensePlateData.cascoInsurancePolicy?.cascoInsuranceNumber || null,
                cascoInsuranceStart: licensePlateData.cascoInsurancePolicy?.cascoInsuranceStart
                    ? new Date(licensePlateData.cascoInsurancePolicy.cascoInsuranceStart)
                    : null,
                cascoInsuranceExpiry: licensePlateData.cascoInsurancePolicy?.cascoInsuranceExpiry
                    ? new Date(licensePlateData.cascoInsurancePolicy.cascoInsuranceExpiry)
                    : null,
            },
        }),
    };
};

export const mapDataPoolToFormData = ({ prevFormData, response }) => {
    const datapoolData = response?.data || response;
    const mappedData = { ...prevFormData };

    mappedData.customerType = 'Bireysel';
    mappedData.clientName = datapoolData.fullName || '';
    mappedData.tcid = datapoolData.tcid || '';
    mappedData.reference = datapoolData.reference || '';
    mappedData.licensePlate = datapoolData.plate || '';
    mappedData.chassisNumber = datapoolData.chassisNumber || '';
    mappedData.accidentDate = datapoolData.accidentDate ? new Date(datapoolData.accidentDate) : null;

    if (datapoolData.phone && Array.isArray(datapoolData.phone)) {
        if (datapoolData.phone.length > 0) {
            mappedData.phoneNumber = datapoolData.phone[0].phone || '';
            mappedData.phoneDescription = 'Ana Telefon';
        }

        if (datapoolData.phone.length > 1) {
            mappedData.phoneNumber2 = datapoolData.phone[1].phone || '';
            mappedData.phoneDescription2 = 'Yedek Telefon';
        }
    }

    if (datapoolData.creator && datapoolData.creator.length > 0) {
        mappedData.recipientOfPowerOfAttorney = `${datapoolData.creator[0].firstName || ''} ${datapoolData.creator[0].lastName || ''}`.trim();
        mappedData.agentId = datapoolData.creator[0].id;
    } else if (datapoolData.user) {
        mappedData.recipientOfPowerOfAttorney = `${datapoolData.user.firstName || ''} ${datapoolData.user.lastName || ''}`.trim();
        mappedData.agentId = datapoolData.user.id;
    }

    if (datapoolData.faultStatus !== undefined) {
        if (datapoolData.faultStatus === 1) {
            mappedData.ourFaultRate = '100';
            mappedData.counterpartyFaultRate = '0';
        } else if (datapoolData.faultStatus === 0) {
            mappedData.ourFaultRate = '0';
            mappedData.counterpartyFaultRate = '100';
        }
    }

    return {
        mappedData,
        canEdit: datapoolData.canEdit !== undefined ? datapoolData.canEdit !== false : true,
    };
};

export const mapExistingFormData = ({
    customer,
    licensePlate,
    accident,
    powerOfAttorney,
    accidentFile,
    accidentFiles,
    allFilesToBeWorked,
    apiData,
    cityId,
    districtId,
}) => {
    const formattedData = {
        customers: customer ? [{ ...customer, created: customer.created ? new Date(customer.created) : null }] : [],
        clientName: customer?.clientName || null,
        companyName: customer?.companyName || null,
        companyRepresentative: customer?.companyRepresentative || null,
        customerType: customer?.customerType || 'Bireysel',
        tcid: customer?.identityNumber || null,
        taxNumber: customer?.taxNumber || null,
        crsNumber: customer?.crsNumber || null,
        recipientOfPowerOfAttorney: customer?.agent ? `${customer.agent.firstName || ''} ${customer.agent.lastName || ''}`.trim() : null,
        agentId: customer?.agent?.id || null,
        reference: customer?.reference || null,
        phoneNumber: customer?.phones && customer.phones.length > 0 ? customer.phones[0].phone : null,
        phoneDescription: customer?.phones && customer.phones.length > 0 ? customer.phones[0].phoneDescription : null,
        phoneNumber2: customer?.phones && customer.phones.length > 1 ? customer.phones[1].phone : null,
        phoneDescription2: customer?.phones && customer.phones.length > 1 ? customer.phones[1].phoneDescription : null,
        email: customer?.emails && customer.emails.length > 0 ? customer.emails[0].email : null,
        emailDescription: customer?.emails && customer.emails.length > 0 ? customer.emails[0].emailDescription : null,
        email2: customer?.emails && customer.emails.length > 1 ? customer.emails[1].email : null,
        emailDescription2: customer?.emails && customer.emails.length > 1 ? customer.emails[1].emailDescription : null,
        iban: customer?.ibans && customer.ibans.length > 0 ? customer.ibans[0].iban : null,
        ibanDescription: customer?.ibans && customer.ibans.length > 0 ? customer.ibans[0].ibanDescription : null,
        iban2: customer?.ibans && customer.ibans.length > 1 ? customer.ibans[1].iban : null,
        ibanDescription2: customer?.ibans && customer.ibans.length > 1 ? customer.ibans[1].ibanDescription : null,
        middleman: customer?.middleman || null,
        middlemanIban: customer?.middlemanIban || null,
        customerContractRate: customer?.contractRate !== undefined ? customer.contractRate?.toString() : null,
        customerEnforcementAttorneyFeeShareRate: customer?.enforcementAttorneyFeeShareRate?.toString() ?? null,
        customerJudgmentAttorneyFeeShareRate: customer?.judgmentAttorneyFeeShareRate?.toString() ?? null,
        customerPayInterestToCustomer: customer?.payInterestToCustomer === true,
        customerIsMiddlemanContractBased: customer?.isMiddlemanContractBased === true,
        customerMiddlemanContractRate: customer?.isMiddlemanContractBased === true ? (customer?.middlemanContractRate !== undefined ? customer.middlemanContractRate?.toString() : null) : null,
        customerMiddlemanContractPrice: customer?.isMiddlemanContractBased === false ? (customer?.middlemanContractPrice !== undefined ? customer.middlemanContractPrice?.toString() : null) : null,
        address: customer?.address || null,
        city: cityId,
        district: districtId,
        licensePlate: licensePlate?.licensePlateNumber || null,
        chassisNumber: licensePlate?.carchassisNumber || null,
        carBrand: licensePlate?.carBrand || null,
        carModel: licensePlate?.carModel || null,
        carYear: licensePlate?.carYear || null,
        hasCarSoldBefore: licensePlate?.hasCarSoldBefore ? 'yes' : 'no',
        isThereLovClaim: licensePlate?.isThereLovClaim ? 'yes' : 'no',
        lovClaimAmount: licensePlate?.lovClaimAmount || null,
        lpImpeachmentStatus: licensePlate?.lpImpeachmentStatus || licensePlate?.lpImpeachmentStatus === true ? 'yes' : 'no',
        lpImpeachmentAmount: licensePlate?.lpImpeachmentAmount || null,
        licensePlateCustomerContractRate: customer?.contractRate !== undefined ? customer.contractRate?.toString() : null,
        licensePlateEnforcementAttorneyFeeShareRate: licensePlate?.enforcementAttorneyFeeShareRate?.toString() ?? null,
        licensePlateJudgmentAttorneyFeeShareRate: licensePlate?.judgmentAttorneyFeeShareRate?.toString() ?? null,
        licensePlatePayInterestToCustomer: licensePlate?.payInterestToCustomer === true,
        licensePlateIsMiddlemanContractBased: licensePlate?.isMiddlemanContractBased === true,
        licensePlateMiddlemanContractRate: licensePlate?.isMiddlemanContractBased === true ? (licensePlate?.middlemanContractRate !== undefined ? licensePlate.middlemanContractRate?.toString() : null) : null,
        licensePlateMiddlemanContractPrice: licensePlate?.isMiddlemanContractBased === false ? (licensePlate?.middlemanContractPrice !== undefined ? licensePlate.middlemanContractPrice?.toString() : null) : null,
        trafficInsurancePolicy: {
            trafficInsuranceProvider: licensePlate?.trafficInsurancePolicy?.trafficInsuranceProvider
                ? (typeof licensePlate.trafficInsurancePolicy.trafficInsuranceProvider === 'object' && !Array.isArray(licensePlate.trafficInsurancePolicy.trafficInsuranceProvider)
                    ? [licensePlate.trafficInsurancePolicy.trafficInsuranceProvider.id]
                    : licensePlate.trafficInsurancePolicy.trafficInsuranceProvider)
                : [],
            trafficInsuranceNumber: licensePlate?.trafficInsurancePolicy?.trafficInsuranceNumber || null,
            trafficInsuranceStart: licensePlate?.trafficInsurancePolicy?.trafficInsuranceStart ? new Date(licensePlate.trafficInsurancePolicy.trafficInsuranceStart) : null,
            trafficInsuranceExpiry: licensePlate?.trafficInsurancePolicy?.trafficInsuranceExpiry ? new Date(licensePlate.trafficInsurancePolicy.trafficInsuranceExpiry) : null,
        },
        cascoInsurancePolicy: {
            cascoInsuranceProvider: licensePlate?.cascoInsurancePolicy?.cascoInsuranceProvider
                ? (typeof licensePlate.cascoInsurancePolicy.cascoInsuranceProvider === 'object' && !Array.isArray(licensePlate.cascoInsurancePolicy.cascoInsuranceProvider)
                    ? [licensePlate.cascoInsurancePolicy.cascoInsuranceProvider.id]
                    : licensePlate.cascoInsurancePolicy.cascoInsuranceProvider)
                : [],
            cascoInsuranceNumber: licensePlate?.cascoInsurancePolicy?.cascoInsuranceNumber || null,
            cascoInsuranceStart: licensePlate?.cascoInsurancePolicy?.cascoInsuranceStart ? new Date(licensePlate.cascoInsurancePolicy.cascoInsuranceStart) : null,
            cascoInsuranceExpiry: licensePlate?.cascoInsurancePolicy?.cascoInsuranceExpiry ? new Date(licensePlate.cascoInsurancePolicy.cascoInsuranceExpiry) : null,
        },
        accidentDate: accident?.accidentDate ? new Date(accident.accidentDate) : null,
        isTrialDocument: accident?.isTrialDocument ? 'yes' : 'no',
        isWorkDocument: accident?.isWorkDocument ? 'yes' : 'no',
        bonusEligibility: accident?.bonusEligibility?.toString() || null,
        shouldPayNotaryFee: accident?.shouldPayNotaryFee ? 'yes' : 'no',
        notaryFeeAmount: accident?.notaryFeeAmount?.toString() || null,
        estimatedDepreciationAmount: accident?.estimatedDepreciationAmount?.toString() || null,
        damageAmount: accident?.damageAmount?.toString() || null,
        damageDifferenceAmount: accident?.damageDifferenceAmount?.toString() || null,
        lorAmount: accident?.loRamount?.toString() || null,
        counterpartyType: accident?.counterpartyType || 'Bireysel',
        counterpartyIdentificationNumber: accident?.counterpartyIdentificationNumber || null,
        counterpartyTaxNumber: accident?.counterpartyTaxNumber || null,
        counterpartyCarOwner: accident?.counterpartyCarOwner || null,
        counterpartyLicensePlateNumber: accident?.counterpartyLicensePlateNumber || null,
        counterpartyAddress: accident?.counterpartyAddress || null,
        counterpartyTrafficInsurancePolicy: {
            trafficInsuranceProvider: accident?.counterpartyTrafficInsurancePolicy?.trafficInsuranceProvider
                ? (typeof accident.counterpartyTrafficInsurancePolicy.trafficInsuranceProvider === 'object' && !Array.isArray(accident.counterpartyTrafficInsurancePolicy.trafficInsuranceProvider)
                    ? [accident.counterpartyTrafficInsurancePolicy.trafficInsuranceProvider.id]
                    : accident.counterpartyTrafficInsurancePolicy.trafficInsuranceProvider)
                : [],
            trafficInsuranceNumber: accident?.counterpartyTrafficInsurancePolicy?.trafficInsuranceNumber || null,
            trafficInsuranceStart: accident?.counterpartyTrafficInsurancePolicy?.trafficInsuranceStart ? new Date(accident.counterpartyTrafficInsurancePolicy.trafficInsuranceStart) : null,
            trafficInsuranceExpiry: accident?.counterpartyTrafficInsurancePolicy?.trafficInsuranceExpiry ? new Date(accident.counterpartyTrafficInsurancePolicy.trafficInsuranceExpiry) : null,
        },
        counterpartyCascoInsurancePolicy: {
            cascoInsuranceProvider: accident?.counterpartyCascoInsurancePolicy?.cascoInsuranceProvider
                ? (typeof accident.counterpartyCascoInsurancePolicy.cascoInsuranceProvider === 'object' && !Array.isArray(accident.counterpartyCascoInsurancePolicy.cascoInsuranceProvider)
                    ? [accident.counterpartyCascoInsurancePolicy.cascoInsuranceProvider.id]
                    : accident.counterpartyCascoInsurancePolicy.cascoInsuranceProvider)
                : [],
            cascoInsuranceNumber: accident?.counterpartyCascoInsurancePolicy?.cascoInsuranceNumber || null,
            cascoInsuranceStart: accident?.counterpartyCascoInsurancePolicy?.cascoInsuranceStart ? new Date(accident.counterpartyCascoInsurancePolicy.cascoInsuranceStart) : null,
            cascoInsuranceExpiry: accident?.counterpartyCascoInsurancePolicy?.cascoInsuranceExpiry ? new Date(accident.counterpartyCascoInsurancePolicy.cascoInsuranceExpiry) : null,
        },
        ourFaultRate: accident?.ourFaultRate?.toString() || null,
        counterpartyFaultRate: accident?.counterPartyFaultRate?.toString() || null,
        powerOfAttorneyNumber: powerOfAttorney?.poaNumber || null,
        powerOfAttorneyDate: powerOfAttorney?.poaDate ? new Date(powerOfAttorney.poaDate) : null,
        isPowerOfAttorneyTimed: powerOfAttorney?.isPoaTimeLimited ? 'yes' : 'no',
        powerOfAttorneyEndDate: powerOfAttorney?.poaEndDate ? new Date(powerOfAttorney.poaEndDate) : null,
        notaryNumber: powerOfAttorney?.notaryOfPoa || null,
        isLicensePlatesLimited: powerOfAttorney?.isLicensePlatesLimited ? 'yes' : 'no',
        plateLimit: powerOfAttorney?.licensePlateLimit || [],
        isAccidentDateLimited: powerOfAttorney?.isAccidentDateLimited ? 'yes' : 'no',
        plateLimitAccidentDate: powerOfAttorney?.licensePlateLimitAccidentDate ? new Date(powerOfAttorney.licensePlateLimitAccidentDate) : null,
        hasOriginalArrived: powerOfAttorney?.poaOriginalArrived ? 'yes' : 'no',
        contractRate: powerOfAttorney?.contractRate !== undefined ? powerOfAttorney.contractRate : (customer?.contractRate || null),
        isThereOpenDamageFile: licensePlate?.isThereOpenDamageFile ? 'yes' : 'no',
        registrationDate: accidentFile?.fileOpenDate ? new Date(accidentFile.fileOpenDate) : null,
        jobToBeWorked: accidentFile?.jobToBeWorked
            ? (Array.isArray(accidentFile.jobToBeWorked)
                ? accidentFile.jobToBeWorked
                : (typeof accidentFile.jobToBeWorked === 'object' && accidentFile.jobToBeWorked.id
                    ? [accidentFile.jobToBeWorked.id]
                    : [accidentFile.jobToBeWorked]))
            : null,
        whoseInsurance: accidentFile?.whoseInsurance || null,
        documentRequestDate: accident?.documentRequestDate ? new Date(accident.documentRequestDate) : null,
        documentRequestStatus: accidentFile?.documentRequestStatus || null,
        documentReceivedDate: accident?.documentReceivedDate ? new Date(accident.documentReceivedDate) : null,
        filesToBeWorked: allFilesToBeWorked,
        accidentFiles,
        hasContractArrived: customer?.contractOriginalArrived ? 'yes' : 'no',
        willLorBeWorked: accident && accident.willLorBeWorked !== undefined ? (accident.willLorBeWorked ? 'yes' : 'no') : 'no',
        needExpertReview: apiData.needExpertReview !== undefined ? apiData.needExpertReview : false,
    };

    if (accidentFile?.jobToBeWorked) {
        if (typeof accidentFile.jobToBeWorked === 'object' && accidentFile.jobToBeWorked !== null && !Array.isArray(accidentFile.jobToBeWorked) && accidentFile.jobToBeWorked.id) {
            formattedData.jobToBeWorkedObject = accidentFile.jobToBeWorked;
            formattedData.jobToBeWorked = [accidentFile.jobToBeWorked.id];
        } else if (Array.isArray(accidentFile.jobToBeWorked)) {
            formattedData.jobToBeWorked = accidentFile.jobToBeWorked.map((job) => (typeof job === 'object' && job !== null && job.id) ? job.id : job);
        } else {
            formattedData.jobToBeWorked = [accidentFile.jobToBeWorked];
        }
    } else {
        formattedData.jobToBeWorked = [];
    }

    return formattedData;
};
